/**
 * 구매하기 내 달력 UI
 * type: datePick(1 depth 혹은 마지막 depth) || checkInOut(항상 마지막 depth)
 * testDeal No: 669317318(숙박상시딜 x) 805424950(숙박상시딜 o)
 * 달력 옵션딜 669317318?opt_deal_srl=880267894
 */
import moment from 'moment';
import Holidays from '../../app/Holidays';

export default class PurchaseCalendar {
  constructor() {
    if (
      !TMON.oApp.getStorage('optionInfo') ||
      TMON.oApp.getStorage('optionInfo').nCalendarDepth < 0
    ) {
      return;
    }

    this.welContainer = $('[data-role="prchCalendarWrap"]');
    this.isCheckInOutSupport = TMON.oApp.getStorage(
      'htStaticData'
    ).htDealInfo.isConstantStay;
    // OptionSelector에서 달력 단계
    this.nCalendarDepth = TMON.oApp.getStorage(
      'optionInfo'
    ).nCalendarDepth;
    this.sCheckinDate = 'not use';
    this.init();
  }

  init() {
    // optionInfo에서 추출한 선택가능한 날짜 리스트
    this.aAVDates = [];
    // 오늘 날짜: moment object
    this.oToday = moment();
    // 보여줄 날짜: moment object
    this.oDate = moment();
    // 공휴일
    this.oHolidays = new Holidays();
    // 요일
    this.aDays = ['일', '월', '화', '수', '목', '금', '토'];

    this.render();
    this.setEvent();
    this.drawSkeleton();

    // 날짜 선택 자동 완성 대비 / TODO: setStorage로 변경
    if (TMON.htStaticData.bOptionDeal) {
      this.drawPick(this.getPickDate());
    }
    this.update('optionTree');
  }

  update(sStorageKey) {
    const { totalDepth } = TMON.oApp.htStorage.optionInfo;
    if (this.nCalendarDepth < 0) {
      // 달력 UI가 사용되지 않는 딜
      return;
    }

    if (sStorageKey === 'purchaseOption') {
      const { nCurrentDepth } = TMON.oApp.htStorage.purchaseOption;

      // 특정 날짜가 선택된 경우
      if (this.nCalendarDepth === nCurrentDepth) {
        if (this.isCheckInOutSupport === false) {
          this.drawPick();
        }
        // 달력 사용 옵션의 상위 옵션이 변경된 경우
      } else if (this.nCalendarDepth - 1 === nCurrentDepth) {
        // 체크인 체크아웃 초기화
        if (this.isCheckInOutSupport) {
          TMON.oApp.setStorage('checkIn', null);
          TMON.oApp.setStorage('checkOut', null);
        }
      }
      // AV 날짜 업데이트 (달력 UI가 옵션 셀럭터 중 첫 번째일 때)
    } else if (
      sStorageKey === "optionTree" &&
      this.nCalendarDepth === 0 &&
      totalDepth !== 1 // depth가 한개인 경우 optionList가 호출되고 난 후 setDates 해준다.
    ) {
      const aChildNodes = this.getCalendarDepthChildNodes();
      this.setDates(
        aChildNodes.map((item, idx) => ({
          key: item.key,
          title: moment(item.value.replace(/[^0-9]/g, '')).format('YYYY-MM-DD'),
          dealNo: 0,
          dealMax: item.dealMax,
          optionTitle: item.optionTitle,
          price: item.price,
          stockCount: item.dealMax.stockCount,
          // 추가할인 노출여부
          discount: aChildNodes[idx].discount,
          index: idx,
        })),
        sStorageKey
      );
      // .filter(item => item.dealMax && !item.dealMax.soldOut)
      // AV 날짜 업데이트 (달력 UI가 옵션 셀럭터 중 마지막일 때)
    } else if (sStorageKey === "optionList" && this.nCalendarDepth === totalDepth - 1) {
      const aOptionList = TMON.oApp.getStorage("optionList").data;

      if (!aOptionList || aOptionList.length === 0) {
        return;
      }
      this.setDates(
        aOptionList.map((item, idx) => ({
          title: moment(
            aOptionList[idx].optionTitle
              .split('|')
              .pop()
              .replace(/[^0-9]/g, '')
          ).format('YYYY-MM-DD'), // title은 optionInfo의 것을 사용한다.
          dealNo: item.optionNo,
          optionTitle: aOptionList[idx].optionTitle.split('|').pop(),
          orderDealMax: item.orderDealMax,
          stockCount: item.orderDealMax.availableBuyCount,
          price: item.priceInfo && item.priceInfo.price,
          discount:
            item.priceInfo.viewPaymentDiscountInfoKey !== 'normal' &&
            item.priceInfo.discountInfos[
              item.priceInfo.viewPaymentDiscountInfoKey
            ].discountAmount > 0,
          index: idx,
        })),
        sStorageKey
      );
      // 체크인
    } else if (sStorageKey === 'checkIn') {
      this.drawCheckIn(true);
      this.setDateTemp();
      // 체크아웃
    } else if (sStorageKey === 'checkOut') {
      this.drawCheckOut();
      // 특정 날짜 선택
    } else if (sStorageKey === 'pickDate') {
      this.welDateWrap.find('li').removeClass('select');
      this.drawPick();
    }
  }

  clearEvent() {
    if (!this.welContainer) {
      return;
    }

    if (this.welContainer) {
      this.welContainer.off('click', 'button[data-role="prchCalPrevMonth"]');
      this.welContainer.off('click', 'button[data-role="prchCalNextMonth"]');
    }
    if (TMON.oApp.isTouchDevice) {
      this.welContainer.off('touchstart', 'li');
      this.welContainer.off('touchend', 'li');
    } else {
      this.welContainer.off('mouseover', 'li');
      this.welContainer.off('mouseleave', 'li');
    }
  }

  setEvent() {
    // 월별 이동
    this.welContainer.on(
      'click',
      'button[data-role="prchCalPrevMonth"].active',
      this.gotoPrevMonth
    );
    this.welContainer.on(
      'click',
      'button[data-role="prchCalNextMonth"].active',
      this.gotoNextMonth
    );

    // 마우스 오버시 가격/수량 툴팁 노출
    if (TMON.oApp.isTouchDevice) {
      this.welContainer.on('touchstart', 'li', e => {
        this.handleTouchPriceToolTip(e);
      });
      this.welContainer.on('touchmove', 'li', e => {
        this.handleTouchPriceToolTip(e);
      });

      this.welContainer.on('touchend', 'li', () => {
        this.hidePriceToolTip();
      });
      this.welContainer.on('touchcancel', 'li', () => {
        this.hidePriceToolTip();
      });
    } else {
      this.welContainer.on('mouseover', 'li', e => {
        this.handleHoverPriceToolTip(e);
      });
      this.welContainer.on('mouseout', 'li', () => {
        this.hidePriceToolTip();
      });
    }

    // 체크인아웃 지원
    if (this.isCheckInOutSupport) {
      // AV 날짜 대상으로 체크인/체크아웃 Event Bind
      this.welContainer.on('click', 'li.enabled:not(.temp) button', e => {
        // 현재 이벤트 상태 체크
        const htResult = this.getEventStatus(e);

        if (htResult.sState === 'checkIn') {
          this.setCheckIn(htResult.sDate);
        } else if (htResult.sState === 'checkOut') {
          this.setCheckOut(htResult.sDate, e);
        }
      });
      // av에 포함되지 않은 날짜라도 체크인 바로 다음 날은 선택(체크아웃)을 할 수 있어야 한다.
      this.welContainer.on('click', 'li.enabled.temp button', e => {
        const sDate = $(e.currentTarget)
          .parents('li')
          .data('date');

        if (!TMON.oApp.htStorage.checkOut) {
          this.setCheckOut(sDate, e);
        }
      });
      // 특정 날짜 선택 지원
    } else {
      this.welContainer.on('click', 'li.enabled button', e => {
        const elWrapper = $(e.currentTarget).parents('li');

        TMON.oApp.setStorage('pickDate', {
          date: elWrapper.data('date'),
          index: elWrapper.data('index'),
          optionNo: elWrapper.data('optionno'),
          event: e,
        });
      });
    }
  }

  setDateTemp = () => {
    if (!TMON.oApp.htStorage.checkIn) {
      return;
    }
    const { sCheckIn, nCheckIn } = TMON.oApp.htStorage.checkIn;
    const oCheckIn = moment(sCheckIn);

    // 체크인 이벤트 발생했을 때만 체크아웃 가능한 날짜의 바로 다음날에 체크 아웃 가능하도록 임시 스타일 지정
    if (this.oDate.get('month') >= oCheckIn.get('month')) {
      let nIndex = nCheckIn;

      do {
        oCheckIn.add(1, 'days');
        nIndex += 1;
      } while (
        this.aAVDates[nIndex] &&
        this.aAVDates[nIndex].title === oCheckIn.format('YYYY-MM-DD')
      );

      this.range.oTemp = oCheckIn;

      this.drawAVDatesTemp();
      // 체크아웃 가능한 날짜가 range 밖의 월일 때 임시로 range 조절
      if (
        oCheckIn.month() > this.range.next.month() ||
        oCheckIn.year() > this.range.next.year()
      ) {
        this.drawRangeTemp();
      }
    }
  };

  gotoPrevMonth = () => {
    if (this.oDate.format('YYYYMM') <= this.range.prev.format('YYYYMM')) {
      return;
    }

    this.welCacheDate = null;

    this.oDate = this.oDate.add(-1, 'M');
    this.oHolidays = new Holidays(this.oDate.year(), this.oDate.isLeapYear());
    this.draw();
  };

  gotoNextMonth = () => {
    if (this.oDate.format('YYYYMM') >= this.range.next.format('YYYYMM')) {
      return;
    }
    // 체크인하고 달력을 넘길때 1일의 툴팁이 전날(이전달 말일) 정보를 표시할 수 있도록 말일의 정보를 캐시해둔다.
    this.welCacheDate = this.welDateWrap
      .first()
      .find('li')
      .last();

    this.oDate = this.oDate.add(1, 'M');
    this.draw();
  };

  handleTouchPriceToolTip(e) {
    // const wel = $(e.currentTarget);
    const myLocation = e.originalEvent.changedTouches[0];
    let welRealTarget = document.elementFromPoint(
      myLocation.clientX,
      myLocation.clientY
    );
    if ($(welRealTarget).hasClass('tooltip')) {
      this.hidePriceToolTip();
      return;
    }
    if ($(welRealTarget).tagName !== 'LI') {
      welRealTarget = $(welRealTarget).closest('li');
    }
    this.showPriceToolTip(welRealTarget);
    if (e.type === 'touchmove') {
      e.preventDefault();
    }
  }

  handleHoverPriceToolTip(e) {
    const welTarget = $(e.target);
    if (welTarget.closest('._priceWrap').length) {
      this.hidePriceToolTip();
      return;
    }

    const welCurrentTarget = $(e.currentTarget);
    this.showPriceToolTip(welCurrentTarget);
  }

  showPriceToolTip(welCurrentTarget) {
    let welInfoTarget = welCurrentTarget;

    // if (!welInfoTarget.hasClass('enabled')) {
    //     return;
    // }

    // 체크인 상태일때 체크인 기준의 정보가 보이도록 한다(앞 날짜의 정보를 가져옴, 예) 토요일 체크인-> 일요일에 hover시 토요일가격 보여줌)
    if (
      this.sCheckinDate !== 'not use' &&
      welCurrentTarget.data('date') &&
      welCurrentTarget.data('date').replace(/-/g, '') > this.sCheckinDate
    ) {
      welInfoTarget = welCurrentTarget.prev().hasClass('enabled')
        ? welCurrentTarget.prev()
        : this.welCacheDate;
    }

    const sPrice = welInfoTarget.data('price');

    if (sPrice) {
      const sCount = welInfoTarget.data('count');
      const bDiscount = welInfoTarget.data('discount');
      let sHtml = `<div class="_priceWrap"><strong class="num">${sPrice}</strong><br>`;
      if (sCount === 'undefined') {
        sHtml += '';
      } else if (sCount && !welCurrentTarget.hasClass('soldout')) {
        sHtml += `<span class="left_num"><span>${sCount}</span>개 남음</span><br>`;
      } else {
        sHtml += '<span class="left_num">매진</span><br>';
      }
  
      if (bDiscount) {
        sHtml += '<em class="discount orange">추가할인</em></div>';
      } else {
        sHtml += '</div>'
      }
      
      this.welTooltip.html(sHtml);
      welCurrentTarget.append(this.welTooltip.show());
    }
  }

  hidePriceToolTip() {
    this.welTooltip.hide();
  }

  getEventStatus = e => {
    const welDate = $(e.currentTarget).parents('li');
    const sDate = welDate.data('date');
    const nIndex = this.aAVDates.findIndex(item => item.title === sDate);

    let sState = '';

    // [체크인]
    // 1. 이전 체크인 값이 없거나 체크인 이전 날짜가 선택되었거나
    if (
      !TMON.oApp.htStorage.checkIn ||
      !TMON.oApp.htStorage.checkIn.sCheckIn ||
      moment(sDate) < moment(TMON.oApp.htStorage.checkIn.sCheckIn)
    ) {
      sState = 'checkIn';
      // 2. 체크 아웃이 선택된 상태거나
    } else if (
      TMON.oApp.htStorage.checkOut &&
      TMON.oApp.htStorage.checkOut.sCheckOut
    ) {
      sState = 'checkIn';
      // 3. 선택된 날짜 사이에 AV 상태가 아닌 날짜가 포함되어 있을 때
    } else if (
      moment(sDate, 'YYYY-MM-DD').diff(
        moment(TMON.oApp.htStorage.checkIn.sCheckIn, 'YYYY-MM-DD'),
        'days'
      ) !==
      nIndex - TMON.oApp.htStorage.checkIn.nCheckIn
    ) {
      // 기존 체크인 날짜로부터 해당 날짜까지의 일(day) 차이와 AVDates에서의 Index 차이의 비교를 통해 두 날짜 간에 AV가 아닌 날짜가 포함되었는지 확인
      sState = 'checkIn';
      // [체크아웃] sDate가 기존의 cehckIn이 아닐 떄
    } else if (TMON.oApp.htStorage.checkIn.sCheckIn !== sDate) {
      sState = 'checkOut';
    }

    return { sState, sDate };
  };

  /**
   * 선택 가능날짜, 모든 판매날짜 등을 array 형태로 저장하기 위한 함수
   */
  setDates = (aDates, sStorageKey) => {
    const sPick = this.getPickDate();
    let bSoldout = true;
    this.aAVDates = [];
    this.aSoldoutDates = [];
    this.aAllDates = aDates;

    for (let i = 0; this.aAllDates.length > i; i += 1) {
      bSoldout = true;
      if (sStorageKey === 'optionTree' && this.aAllDates[i].dealMax) {
        bSoldout = this.aAllDates[i].dealMax.soldOut;
      }
      if (sStorageKey === 'optionList' && this.aAllDates[i].orderDealMax) {
        bSoldout = this.aAllDates[i].orderDealMax.soldOut;
      }
      if (
        sStorageKey === 'optionList' &&
        this.aAllDates[i].endDate &&
        !bSoldout
      ) {
        try {
          bSoldout = TMON.oApp.oUtil.isTimeOver(this.aAllDates[i].endDate);
        } catch (e) {
          console.warn(e);
        }
      }
      if (bSoldout) {
        this.aSoldoutDates.push(this.aAllDates[i]);
      } else {
        this.aAVDates.push(this.aAllDates[i]);
      }
    }

    if (sPick) {
      this.oDate = moment(sPick, 'YYYY-MM-DD');
    } else if (this.aAVDates.length > 0 && this.aAVDates[0].title) {
      this.oDate = moment(this.aAVDates[0].title, 'YYYY-MM-DD');
    }

    if (this.aAllDates.length > 0) {
      this.range = {
        prev: moment(this.aAllDates[0].title, 'YYYY-MM-DD'),
        next: moment(
          this.aAllDates[this.aAllDates.length - 1].title,
          'YYYY-MM-DD'
        ),
      };
    }

    this.draw();
  };

  setCheckIn = sCurDate => {
    const nCheckIn = this.aAVDates.findIndex(item => item.title === sCurDate);

    // 임시로 range를 조정했을 경우 원상 복구
    if (this.range && this.range.isTempAdj) {
      this.clearRangeTemp();
    }

    // checkIn
    TMON.oApp.setStorage('checkIn', {
      sCheckIn: sCurDate,
      sCheckInOptionTitle: this.aAVDates[nCheckIn].optionTitle,
      nCheckIn,
    });

    // checkOut, temp 해제
    TMON.oApp.setStorage('checkOut', null);

    // InnerCart 초기화
    TMON.oApp.setStorage('innerCartItems', {
      sAction: 'initialize',
      aList: [],
    });

    this.sCheckinDate = sCurDate.replace(/-/g, '');
  };

  setCheckOut = (sCurDate, event) => {
    const { htRefined } = TMON.oApp.htStorage.optionList;
    const aStayInDayList = [];
    const nAVIndex = this.aAVDates.findIndex(item => item.title === sCurDate);

    let nLastStayIndex = 0;
    let sCheckOutTitle = '';

    // 실제로 AVDates에 존재하는 날짜가 아닌 날짜가 체크아웃으로 선택되었을 때(.temp) 예외 처리
    if (nAVIndex < 0) {
      // 1. 임시 체크아웃의 바로 전날을 찾는다.
      const sCheckOutBeforeDay = moment(sCurDate)
        .subtract(1, 'days')
        .format('YYYY-MM-DD');
      // 2. nLaststayIndex를 1.에서 구한 날짜의 AVDate 리스트 상 다음 인덱스로 대체
      nLastStayIndex =
        this.aAVDates.findIndex(item => item.title === sCheckOutBeforeDay) + 1;
      // 3. 임시 체크아웃은 optionTitle를 갖고 있지 않으므로 날짜로 대체한다.
      sCheckOutTitle = [
        sCurDate,
        `(${this.aDays[moment(sCurDate).day()]})`,
      ].join('');
    } else {
      nLastStayIndex = nAVIndex;
      sCheckOutTitle = this.aAVDates[nLastStayIndex].optionTitle;
    }

    this.getStayInDays(nLastStayIndex).forEach(item => {
      try {
        const htItem = $.extend({}, htRefined[item.dealNo]);
        htItem.count = 1;
        aStayInDayList.push(htItem);
      } catch (e) {
        console.error(e);
      }
    });

    TMON.oApp.setStorage('checkOut', {
      // nCheckOut,
      sCheckOut: sCurDate,
      sCheckOutOptionTitle: sCheckOutTitle,
      event,
    });
    // option 리스트(checkIn-checkOut)를 InnerCart에서는 하나의 옵션으로 취급
    TMON.oApp.setStorage('innerCartItems', {
      sAction: 'join',
      sOptionTitle: `${
        htRefined[aStayInDayList[0].optionNo].optionTitle
      } ~ ${sCheckOutTitle} (${
        aStayInDayList.length
      }박 ${aStayInDayList.length + 1}일)`,
      aList: aStayInDayList,
    });

    this.sCheckinDate = 'not use';
  };

  getCalendarDepthChildNodes = () => {
    const { optionInfo, optionList } = TMON.oApp.htStorage;
    const { totalDepth } = optionInfo;

    if (this.nCalendarDepth !== totalDepth - 1) {
      return optionInfo.options[0];
    }

    return optionList && optionList.data;
  };

  getPickDate = () => {
    const aKeyList = TMON.oApp.getStorage('purchaseOption')
      ? TMON.oApp.getStorage('purchaseOption').aKeyList
      : [];
    const aCalendarDateList = this.getCalendarDepthChildNodes();

    if (!aKeyList[this.nCalendarDepth]) {
      return null;
    }

    let pickDate = '';
    const { totalDepth } = TMON.oApp.htStorage.optionInfo;
    // 캘린더 옵션이 마지막 뎁스일 때
    if (this.nCalendarDepth === totalDepth - 1) {
      pickDate = aCalendarDateList
        .find((el) => el.optionNo === +aKeyList[this.nCalendarDepth])
        .optionTitle.split("|")
        .pop();
    } else {
      pickDate = aCalendarDateList.find((el) => el.key === aKeyList[this.nCalendarDepth]).value;
    }

    return moment(pickDate.replace(/[^0-9]/g, "")).format("YYYY-MM-DD");
  };

  getStayInDays = nCheckOut => {
    if (!TMON.oApp.htStorage.checkIn || !nCheckOut) {
      return [];
    }

    let nIndex = TMON.oApp.htStorage.checkIn.nCheckIn;
    const aOptions = [];
    const nMax = isNaN(nCheckOut) || nCheckOut < 0 ? nIndex + 1 : nCheckOut;

    for (nIndex; nIndex < nMax; nIndex += 1) {
      aOptions.push(this.aAVDates[nIndex]);
    }

    return aOptions;
  };

  getDayClassName(date, col) {
    let className = '';

    // 오늘
    if (date > 0 && this.oToday.isSame(this.oDate.set('date', date), 'days')) {
      className += ' today ';
    }

    // 주말
    if (col === 6) {
      className += ' sat ';
    } else if (col === 0) {
      className += ' sun ';
    }

    return className;
  }

  getCellDate(date) {
    if (date <= 0) {
      return '';
    }

    return this.oDate.format('YYYY-MM-DD');
  }

  draw() {
    this.drawSkeleton();
    this.drawHolidays();
    this.enableCell();

    this.drawPick();
    this.drawCheckIn();
    this.drawCheckOut();
    this.drawAVDatesTemp();

    if (this.range) {
      // 임시로 range를 조정했는데 불필요할 경우 원상 복우
      // if (this.range.isTempAdj && TMON.oApp.htStorage.checkOut && this.aAVDates.findIndex(item => item.title === sCheckOut) === -1) {
      //     this.clearRangeTemp();
      // }
      const bPrevAvailable =
        this.range.prev.get('month') < this.oDate.get('month') ||
        this.range.prev.get('year') < this.oDate.get('year');
      const bNextAvailable =
        this.range.next.get('month') > this.oDate.get('month') ||
        this.range.next.get('year') > this.oDate.get('year');
      $('button[data-role="prchCalPrevMonth"]')[
        bPrevAvailable ? 'addClass' : 'removeClass'
      ]('active');
      $('button[data-role="prchCalNextMonth"]')[
        bNextAvailable ? 'addClass' : 'removeClass'
      ]('active');
    }

    TMON.oApp.setStorage('drawCalenderFinish', true);
  }

  // 달력 뼈대 그리기
  drawSkeleton() {
    this.welYearMonth.html(this.oDate.format('YYYY.MM'));
    this.drawCell();
  }

  drawPick() {
    const sPick = this.getPickDate();
    if (!sPick) {
      this.welDateWrap.find('li').removeClass('select');
    }
    this.welDateWrap.find(`li[data-date="${sPick}"]`).addClass('select');
  }

  drawCheckIn() {
    if (!TMON.oApp.htStorage.checkIn) {
      this.welDateWrap.find('li').removeClass('chk_in_day');
      return;
    }

    const { sCheckIn } = TMON.oApp.htStorage.checkIn;

    this.welDateWrap.find('li').removeClass('chk_in_day');
    this.welDateWrap.find(`li[data-date="${sCheckIn}"]`).addClass('chk_in_day');
  }

  drawCheckOut() {
    if (!TMON.oApp.htStorage.checkIn || !TMON.oApp.htStorage.checkOut) {
      this.welDateWrap.find('li').removeClass('stay_in chk_out_day');
      return;
    }

    const { sCheckIn } = TMON.oApp.htStorage.checkIn;
    const { sCheckOut } = TMON.oApp.htStorage.checkOut;

    // 현재 날짜가 체크인 이전 혹은 체크아웃 이후일 경우 그리지 않는다.
    // 지금 보여지는 달이 체크인 이전달이거나 체크아웃 이후달 일 경우 그리지 않는다. todo 주석
    const oView = {
      nYear: this.oDate.year(),
      nMonth: this.oDate.month(),
    };
    const oCheckIn = {
      nYear: moment(sCheckIn).year(),
      nMonth: moment(sCheckIn).month(),
    };
    const oCheckOut = {
      nYear: moment(sCheckOut).year(),
      nMonth: moment(sCheckOut).month(),
    };
    const aPoint = [oView, oCheckIn, oCheckOut];
    const aYears = [oView.nYear, oCheckIn.nYear, oCheckOut.nYear];
    aYears.sort();
    aPoint.forEach((item, index) => {
      if (item.nYear > aYears[0]) {
        // 1년 이상 차이나지 않는다는 가정하에
        aPoint[index].nMonth += 12;
      }
    });

    if (oView.nMonth < oCheckIn.nMonth || oView.nMonth > oCheckOut.nMonth) {
      return;
    }

    const elCheckOut = this.welDateWrap.find(`li[data-date="${sCheckOut}"]`);
    const elCheckIn = this.welDateWrap.find(`li[data-date="${sCheckIn}"]`);

    const nStart = elCheckIn.length > 0 ? elCheckIn.index() + 1 : 0;
    const nEnd =
      elCheckOut.length > 0
        ? elCheckOut.index()
        : this.welDateWrap.find('li.enabled:last-child').index() + 1;

    // 체크인과 체크아웃 사이의 stay_in 클래스 적용
    for (let i = 0; this.welDateWrap.length > i; i += 1) {
      $(this.welDateWrap[i])
        .find('li')
        .slice(nStart, nEnd)
        .each((idx, item) => {
          if ($(item).data('date') !== '') {
            $(item).addClass('stay_in');
          }
        });
    }

    if (this.aAVDates.findIndex(item => item.title === sCheckOut) > -1) {
      // Checkout AV Date
      elCheckOut.addClass('chk_out_day');
      this.welDateWrap.find('li.temp').removeClass('temp enabled');

      // Temp Range 초기화
      if (this.range && this.range.isTempAdj) {
        this.clearRangeTemp();
      }
    } else {
      // Checkout Temp Date
      elCheckOut.addClass('chk_out_day temp enabled');
    }
  }

  drawAVDatesTemp = () => {
    if (!this.range || !this.range.oTemp) {
      return;
    }

    const elNextDay = this.welDateWrap.find(
      `li[data-date="${this.range.oTemp.format('YYYY-MM-DD')}"]`
    );

    if (elNextDay) {
      this.welDateWrap.find('li.temp').removeClass('temp enabled');
      elNextDay.addClass('temp enabled');
    }
  };

  drawRangeTemp = () => {
    this.range.next = this.range.next.add(1, 'M');
    this.range.isTempAdj = true;
    this.welContainer
      .find('button[data-role="prchCalNextMonth"]')
      .addClass('active');
  };

  clearRangeTemp = () => {
    this.range.isTempAdj = false;
    this.range.oTemp = null;
    this.range.next = this.range.next.add(-1, 'M');
    if (this.range.next.month() === this.oDate.month()) {
      this.welContainer
        .find('button[data-role="prchCalNextMonth"]')
        .removeClass('active');
    }
  };

  drawCell() {
    const firstDayIndex = this.oDate.set('date', 1).day(); // 월화수목금토일 number
    const length = this.oDate.daysInMonth() + firstDayIndex; // 공백 날짜가 포함된 그려야할 셀 개수

    let html = '';
    let curDate = null;

    Array.from({ length }, (v, k) => k).map(num => {
      curDate = num - firstDayIndex + 1;

      html += `<li
                  class="${this.getDayClassName(
                    curDate,
                    parseInt(num % 7, 10)
                  )} "
                  data-date="${this.getCellDate(curDate)}"
                >
                    <button><span class="date">${
                      curDate > 0 ? curDate : ''
                    }</span></button>
                </li>`;

      return true;
    });

    this.welDateWrap.html(html);
  }

  drawHolidays() {
    if (!this.aHolidays || this.oHolidays.year !== this.oDate.year()) {
      this.aHolidays = this.oHolidays.getDates(this.oDate.year());
    }

    let welDate = null;

    const oDate = moment(this.oDate.year(), 'YYYY');

    this.aHolidays.map(item => {
      oDate.month(item.nMonth - 1).date(item.nDay);
      welDate = this.welDateWrap.find(
        `li[data-date=${oDate.format('YYYY-MM-DD')}]`
      );
      // 해당 달에 공휴일이 있음
      if (welDate) {
        // 대체 공휴일: 설,추석연휴와 어린이날이 다른 공휴일과 겹칠경우 생김, 어린이날만 토요일인 경우에도 월요일에 대체 휴무
        const aAlternativeHolidays = [
          '설날',
          '설날전날',
          '설날다음날',
          '어린이날',
          '추석',
          '추석전날',
          '추석다음날',
          '한글날',
        ];

        if (
          (welDate.hasClass('sun') &&
            aAlternativeHolidays.indexOf(item.sName) !== -1) ||
          (welDate.hasClass('sat') && item.sName === '어린이날')
        ) {
          do {
            welDate = welDate.next();
          } while (welDate && welDate.hasClass('sun'));
        }

        welDate.addClass('holiday');

        return true;
      }

      return false;
    });
  }

  enableCell() {
    let sDate = null;
    this.aAVDates.map(item => {
      try {
        sDate = moment(item.title.replace(/[^0-9]/g, '')).format('YYYY-MM-DD'); // 2018-05-23(수)
        if (sDate) {
          this.addClassToCell({
            htItemInfo: item,
            sStatus: 'enabled',
            sDate,
          });
        }
        return sDate;
      } catch (e) {
        console.error(e);
      }
      return false;
    });
    this.aSoldoutDates.map(item => {
      try {
        sDate = moment(item.title.replace(/[^0-9]/g, '')).format('YYYY-MM-DD'); // 2018-05-23(수)
        if (sDate) {
          this.addClassToCell({
            htItemInfo: item,
            sStatus: 'soldout',
            sDate,
          });
        }
        return sDate;
      } catch (e) {
        console.error(e);
      }
      return false;
    });
  }

  /**
   *
   * @param {*} htProps
   * htProps.htItemInfo : 해당 날짜의 정보
   * htProps.sStatus : enabled / soldout
   * htProps.sDate : 날짜
   */
  addClassToCell(htProps) {
    this.welDateWrap
      .find(`li[data-date="${htProps.sDate}"]`)
      // .addClass(item.isSoldout ? '' : 'enabled')
      .addClass(htProps.sStatus)
      .attr('data-index', htProps.htItemInfo.index)
      .attr('data-optionno', htProps.htItemInfo.dealNo)
      .attr(
        'data-price',
        `${TMON.util.numberWithComma(htProps.htItemInfo.price)}원`
      )
      .attr('data-count', `${htProps.htItemInfo.stockCount}`)
      .attr('data-discount', htProps.htItemInfo.discount)
      .attr('data-key', htProps.htItemInfo.key || htProps.htItemInfo.dealNo)
      .find('button');
  }

  render() {
    const sHtml = `<div class="calendar_header">
            <span class="tit" data-role="prchCalendarYearMonth"></span>
            <button type="button" class="btn_prev" data-role="prchCalPrevMonth">
                <span>이전달</span>
            </button>
            <button type="button" class="btn_next" data-role="prchCalNextMonth">
                <span>다음달</span>
            </button>
        </div>
        <div class="calendar_content">
            <ul class="cal_day_list">
                ${this.aDays
                  .map(
                    (item, index) =>
                      `<li class="day ${index === 0 ? 'sun' : ''} ${
                        index === 6 ? 'sat' : ''
                      }">${item}</li>`
                  )
                  .join('')}
            </ul>
            <ul class="cal_date_list" data-role="prchCalDateWrap"></ul>
        </div>`;
    this.welContainer.html(sHtml);

    this.welYearMonth = this.welContainer.find(
      '[data-role="prchCalendarYearMonth"]'
    );
    this.welDateWrap = this.welContainer.find('[data-role="prchCalDateWrap"]');
    this.welTooltip = $('<div class="tooltip"></div>');
  }
}
